export const damageColor = 0xff8888